import { useUserStore } from "~/stores/user";

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (process.client) {
    const userStore= useUserStore();

    const { getSteps } = useOnboarding();

    if (userStore.getAccount && userStore.getAccount.onboarding_step >= getSteps().length) {
      return navigateTo('/account/dashboard');
    }
  }
});



